import { render, staticRenderFns } from "./cadinformacoescomplementares.vue?vue&type=template&id=64098d0c&"
import script from "./cadinformacoescomplementares.vue?vue&type=script&lang=js&"
export * from "./cadinformacoescomplementares.vue?vue&type=script&lang=js&"
import style0 from "./cadinformacoescomplementares.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports